import { createFileRoute } from '@tanstack/react-router';
import { DepositsListPage } from '@/features/deposits-list/deposits-list-page.js';
import { depositsSearchSchema } from '@/features/deposits-list/search.js';

export const Route = createFileRoute('/_app/deposits/')({
  validateSearch: depositsSearchSchema,
  component: DepositsListRoute,
});

function DepositsListRoute(): React.JSX.Element {
  const search = Route.useSearch();
  const navigate = Route.useNavigate();
  return (
    <DepositsListPage
      search={search}
      onSearchChange={(next) => void navigate({ search: next, replace: true })}
    />
  );
}
